<h1 class="custom-dialog-title" mat-dialog-title>
  <ng-container *ngIf="type == 'Autopilot'">
    <ng-container *ngIf="requestId != null; else allTriggers">
      Translate  <span class="primary-color">{{requestName}}</span>
    </ng-container>

    <ng-template #allTriggers>
      Translate all triggers
    </ng-template>
  </ng-container>

  <ng-container *ngIf="type == 'ApplicationPhone'">
    <span *ngIf="isModule">Translate phone module</span>
    <span *ngIf="!isModule">Translate application phone</span>
  </ng-container>
</h1>

<div mat-dialog-content class="p-0">
  <div *ngIf="type == 'ApplicationPhone' && hasVersion">
    <mat-form-field class="w-100 custom-select-padding">
      <mat-label>Version</mat-label>
      <mat-select [formControl]="phoneVersion">
        <mat-option *ngFor="let item of phoneVersions" [value]="item.version" [disabled]="item.translationInProgress">
          {{ item.version === 0 ? 'Original' : item.version }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="hasVersion==false || (hasVersion && phoneVersion.value >0)">
    <ng-container *ngIf="type == 'Autopilot'">
      From the default language <b>{{defaultLanguage}}</b> to all selected languages:
    </ng-container>

    <ng-container *ngIf="type == 'ApplicationPhone'">
      From the default language to all selected languages:
    </ng-container>

    <span *ngFor="let item of languageNames; let last = last">
      <b>{{item}}</b><span *ngIf="!last">,&nbsp;</span>
    </span>
  </div>

  <span class="mb-1 text-warning-color" *ngIf="hasVersion==false || (hasVersion && phoneVersion.value >0)">
    <span class="small">
      <span>
        <span class="lni-warning"></span>
        All manual and automatic translations will be overwritten.
        We use automation tools for translation, so please verify the accuracy once completed.
      </span>
    </span>
  </span>
</div>

<div mat-dialog-actions *ngIf="hasVersion==false || (hasVersion && phoneVersion.value >0)">
  <button mat-button (click)="cancel()">Cancel</button>

  <button [disabled]="loading" mat-raised-button cdkFocusInitial color="accent" (click)="translate()"> Translate </button>
</div>
